<template>
  <organism-site-management
    :fields="fields"
    :items="siteList"
    :filter="filter"
    @onChangeFilter="handleChangeFilter"
  />
</template>

<script>
import { getSiteLocationList } from "@/api/api-module-data"
import OrganismSiteManagement from "@/components/organisms/globalSetting/dataManagement/site/OrganismSiteManagement.vue"
import mixins from "@/mixins"
import { DateTime } from "luxon"

export default {
  name: "SiteManagement",
  components: { OrganismSiteManagement },
  mixins: [mixins],
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "NAME",
          thStyle: { "min-width": "250px" },
          tdStyle: { "min-width": "250px" },
        },
        {
          key: "location",
          label: "TOTAL LOCATION",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "updated",
          label: "UPDATED AT",
        },
      ],
      siteList: [],

      filter: {
        siteName: undefined,
        pageNumber: 1,
      },

    }
  },
  mounted() {
    this.getSite()
  },
  methods: {
    handleChangeFilter(filter) {
      this.filter = {
        siteName: filter.siteName ?? undefined,
        pageNumber: filter.pageNumber,
      }

      this.getSite()
    },

    async getSite() {
      this.showLoading(true)
      await getSiteLocationList(this.filter)
        .then((response) => {
          this.siteList = response.data.map((siteItem) => ({
            id: siteItem.siteId,
            name: siteItem.siteName,
            location: siteItem.totalLocation,
            updated: {
              date: siteItem.updatedAt
                ? DateTime.fromISO(siteItem.updatedAt).toFormat("dd/MM/yyyy")
                : "-",
              time: siteItem.updatedAt
                ? DateTime.fromISO(siteItem.updatedAt).toFormat("HH:mm:ss")
                : "",
            },
          }))

          this.filter.currentPage = response.currentPage
        })
        .finally(() => {
          this.showLoading(false)
        })
    },
  },
}
</script>
